<template src="./datatable.html">
</template>
<script>
  import Vue from 'vue'
  import Loader from '@/components/misc/Loader'
  import queryString from 'qs'
  import { EventBus } from '@/router/bus'
  import { getDatatableInfo, setDatatableInfo, getAccessToken } from '@/utils/cookie'
  import FileSaver from 'file-saver'
  import { hasInvoiceExportClaim } from '@/router/auth'
  import Datepicker from '@/utils/datepicker/'
  import { srCYRL, sr, en } from '@/utils/datepicker/locale'
  import Moment from 'moment'
  import { Money } from 'v-money'

  let uuid = 0

  function getCurrentDatatableKey (self) {
    if (self.$options.propsData['name'] && self.$options.propsData['name'].length > 0) {
      return self.$options.propsData['name']
    }
    return self.$options.propsData['url']
  }

  function getCurrentDatatableInfo (self) {
    var key = getCurrentDatatableKey(self)
    var dataTableInfo = getDatatableInfo(key)
    return dataTableInfo
  }

  function setCurrentDatatableInfo (self, dataTableInfo) {
    var key = getCurrentDatatableKey(self)
    setDatatableInfo(key, dataTableInfo)
  }

  export default {
    name: 'datatable',
    components: {
      Loader,
      Datepicker,
      Money
    },
    data () {
      return {
        // TODO: Move to proprs
        dateFormat: this.$store.getters.dateFormat,
        // TODO: Move to proprs
        dateLocale: srCYRL,
        currentPage: 1,
        totalRows: 0,
        checkboxAll: false,
        checked: {},
        load: false,
        data: [],
        sortBy: null,
        sortDesc: null,
        paginationText: null,
        perPage: 0,
        filterModel: {},
        defaultOptions: {
          sortable: true,
          filter: true,
          filterDelay: 500,
          checkboxValue: 'id',
          per_page_options: [5, 10, 15, 25, 50],
          per_page_default: 5,
          checkboxes: true,
          payloadsTotalPropertyName: 'count',
          additionalQueryParameter: '',
          statuses: null,
          invalidRowMarker: null,
          hiddenRowMarker: null,
          highlightedRowMarker: null,
          altHighlightedRowMarker: null,
          detailsLink: null,
          partialCount: false
        },
        sendNoCount: false,
        query: {
          parameters: {
            filter: {}
          }
        },
        // TODO: put this in a prop
        currency: {
          decimal: this.$store.getters.decimalFormat,
          thousands: this.$store.getters.decimalFormat === ',' ? '.' : ',',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        sendFilter: '',
        hasInvoiceExportClaim: false
      }
    },
    watch: {
      /**
       * Watch for a change on a pagination, then send a request
       */
      currentPage () {
        this.pushModelToUrl()
        this.getCurrentPage()
      },
      '$route' () {
        this.pushUrlToModel()
      },
      /**
       * This is fired whenever any of the filters is changed,
       * here we need to set those new values into the url's queryString
       * WITHOUT firing a changedevent, that is why we use replace() instead
       * of push() at the end line
       */
      filterModel: {
        handler: function () {
          this.pushModelToUrl()
        },
        deep: true
      },
      totalRows: {
        handler: function () {
          this.createPaginationText()
        },
        deep: true
      }
    },
    props: {
      url: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      reportsUrl: {
        type: String,
        default: ''
      },
      hasRowDetails: {
        type: Boolean,
        default: true
      },
      columns: {
        type: Array,
        default: function () {
          return []
        }
      },
      options: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    computed: {
      opt () {
        return Object.assign(this.defaultOptions, this.options)
      },
      generateReportVisible () {
        return this.reportsUrl && this.reportsUrl.length > 0
      }
    },
    methods: {
      pushUrlToModel () {
        if (this.dontFireModelToUrl) {
          this.dontFireModelToUrl = false
          return
        }
        Object.keys(this.$route.query).forEach((key) => {
          if (key === 'currentPageSize') {
            this.perPage = parseInt(this.$route.query[key])
          } else if (key === 'currentPage') {
            this.currentPage = parseInt(this.$route.query[key])
          } else {
            Vue.set(this.filterModel, key, this.$route.query[key])
          }
        })
      },
      getCurrentPage () {
        this.query.parameters.page = this.currentPage

        var dataTableInfo = getCurrentDatatableInfo(this)
        if (!dataTableInfo) { dataTableInfo = {} }
        dataTableInfo.currentPage = this.currentPage
        dataTableInfo.currentPageSize = this.perPage
        setCurrentDatatableInfo(this, dataTableInfo)
        // TODO: change currentPage and currentPAgeSize to url's QS
        this.sendRequest()
      },
      isRowInvalid (row) {
        if (!this.opt.invalidRowMarker) { return false }

        return this.opt.invalidRowMarker.criteria(row, this.opt.statuses)
      },
      isRowHidden (row) {
        if (!this.opt.hiddenRowMarker) { return false }

        return this.opt.hiddenRowMarker.criteria(row)
      },
      isRowHighlighted (row) {
        if (!this.opt.highlightedRowMarker) { return false }

        return this.opt.highlightedRowMarker.criteria(row, this.opt.statuses)
      },
      isRowAltHighlighted (row) {
        if (!this.opt.altHighlightedRowMarker) { return false }

        return this.opt.altHighlightedRowMarker.criteria(row, this.opt.statuses)
      },
      rowDetailsLink (row) {
        if (!this.opt.detailsLink) { return '#' }
        return this.opt.detailsLink.createLink(row)
      },

      filter (event) {
        if (event && [37, 38, 39, 40].includes(event.keyCode)) {
          return
        } else {
          clearTimeout(this.sendFilter)
          this.sendFilter = setTimeout(() => {
            this.sendFilterRequest()
          }, this.opt.filterDelay)
        }
      },
      sendFilterRequest () {
        this.query.parameters.page = 1
        this.sendNoCount = false
        this.sendRequest()
      },
      /**
       * This will run after selecting different option in the list
       */
      changePerPage () {
        this.query.parameters['perPage'] = this.perPage
        this.pushModelToUrl()
        this.getCurrentPage()
      },
      /**
       * Returns values in array of checked boxes
       * @returns []
       */
      arrayOfChecked () {
        let ids = this.checked

        Object.keys(ids).forEach((key) => {
          if (!ids[key]) delete ids[key]
        })
        return Object.keys(ids)
      },
      /**
       * Emit event on every single check.
       */
      checkedSingle () {
        this.$emit('checked', this.arrayOfChecked())
      },
      /**
       * It'll check/uncheck all chekboxes.
       *
       * This method will be called after clicking on
       * checkbox at the top of the column.
       */
      checkAll () {
        let checkboxes = document.querySelectorAll('.chk')
        let state = this.checkboxAll
        let checked = {}

        for (let i = 0; i < checkboxes.length; i++) {
          checked[checkboxes[i].value] = state
        }
        // checkboxes.forEach((el) => {
        //   checked[el.value] = state
        // })
        this.checked = checked
        this.$emit('checked', this.arrayOfChecked())
      },
      /**
       * This will uncheck all boxes include the checkAll box.
       * It will also clear checked property and set checkboxAll to false.
       */
      resetCheckboxes () {
        if (this.opt.checkboxesPersist === false) {
          this.checked = {}
          this.checkboxAll = false
        }
      },
      /**
       * Defines a heading column content.
       * @param column
       * @returns {*}
       */
      columnTitle (column) {
        return column.title
      },
      /**
       * Defines classes for sort icon.
       * @param column
       * @returns {string}
       */
      sortIconClasses (column) {
        let classes = ''
        let sortActive = this.sortBy === column.columnName
        let sortActiveClass = sortActive ? 'active' : ''
        let sortIconClass = this.sortDesc === true && sortActive ? 'down' : 'up'
        classes = sortActiveClass + ' ' + sortIconClass
        return classes
      },
      /**
       * Sort change.
       */
      sort (column) {
        this.sortDesc = this.sortDesc === null || (
          this.sortBy !== column.columnName &&
          (this.sortDesc === null || this.sortDesc === false)
        )
          ? this.sortDesc = false
          : this.sortDesc = !this.sortDesc
        this.sortBy = column.columnName
        this.query.parameters['sortBy'] = this.sortBy
        this.query.parameters['sortDesc'] = this.sortDesc
        this.sendRequest()
      },
      /**
       * URL query builder.
       * @returns {string}
       */
      buildQuery () {
        let params = JSON.parse(JSON.stringify(this.query.parameters))
        Object.keys(params.filter).forEach((key) => {
          if (!params.filter[key]) {
            delete params.filter[key]
          }
        })
        let query = queryString.stringify(params)
        if (this.opt.additionalQueryParameter && this.opt.additionalQueryParameter.length > 0) {
          if (this.opt.additionalQueryParameter !== 'noCount') {
            query += '&' + this.opt.additionalQueryParameter
          }
        }
        if (this.sendNoCount) {
          query += '&noCount'
        }
        return query.length === 0 ? '' : '?' + query
      },
      prepareFromRangeValue (column) {
        this.query.parameters.filter[column.columnRange[0].value] = this.flattenDecimal(this.query.parameters.filter[column.columnRange[0].value])
        this.sendRequest()
      },
      prepareToRangeValue (column) {
        this.query.parameters.filter[column.columnRange[1].value] = this.flattenDecimal(this.query.parameters.filter[column.columnRange[1].value])
        this.sendRequest()
      },
      flattenDecimal (decimal) {
        let commaIndex = decimal.indexOf(',')
        let dotIndex = decimal.indexOf('.')
        if (commaIndex >= 0 && dotIndex >= 0) {
          return decimal.replace('.', '').replace(',', '.')
        } else if (commaIndex >= 0) {
          return decimal.replace(',', '.')
        }

        return decimal
      },
      /**
       * Send a http request.
       */
      sendRequest () {
        this.load = true
        let url = this.url + this.buildQuery()
        Vue.http.headers.common['Authorization'] = 'Bearer ' + getAccessToken()
        this.logConsole(url)
        return this.$http.get(url).then((response) => {
          this.data = response.data.payload
          this.load = false
          if (response.data[this.opt.payloadsTotalPropertyName]) {
            this.totalRows = response.data[this.opt.payloadsTotalPropertyName]
            this.sendNoCount = true
          }
          this.resetCheckboxes()
        }, (error) => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.load = false
        })
      },
      rowSelected (row) {
        this.$emit('rowSelected', row)
      },
      calculateSummary (columnName) {
        if (columnName) {
          let summary = 0
          for (let i = 0; i < this.data.length; i++) {
            if (!this.isRowHidden(this.data[i])) {
              summary += this.data[i][columnName]
            }
          }
          return this.formatAmount(summary)
        }
      },
      generateReport () {
        this.load = true
        let url = this.reportsUrl + this.buildQuery()
        this.logConsole(url)
        return this.$http.get(url, {responseType: 'arraybuffer'})
        .then((response) => {
          this.load = false
          var headers = response.headers
          var blob = new Blob([response.data], {type: headers['content-type']})
          FileSaver.saveAs(blob, 'report.xlsx')
        }, (error) => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.load = false
        })
      },
      customFormatter (date) {
        Moment.locale(this.$store.getters.dateLocale)
        return Moment(date).format(this.dateFormat)
      },
      inputFormat (date) {
        Moment.locale(this.$store.getters.dateLocale)
        return Moment(date, this.dateFormat).valueOf()
      },
      pushModelToUrl () {
        let params = JSON.parse(JSON.stringify(this.filterModel))
        Object.keys(params).forEach((key) => {
          if (!params[key]) {
            delete params[key]
          }
        })
        if (this.currentPage) {
          params.currentPage = this.currentPage
        }
        if (this.perPage) {
          params.currentPageSize = this.perPage
        }
        let queryStr = queryString.stringify(params)
        this.dontFireModelToUrl = true
        this.$router.replace({path: this.$route.path + '?' + queryStr})
      },
      applyFilterInput (target) {
        this.$refs[target][0].hide(true)
        this.sendFilterRequest()
      },
      retrieveCount () {
        this.query.parameters.countAll = 1
        this.defaultOptions.partialCount = false
        this.sendNoCount = false
        this.sendRequest()
      },
      createPaginationText () {
        let to = this.perPage * (this.currentPage - 1) + this.perPage
        to = to > this.totalRows ? this.totalRows : to
        this.paginationText = this.$t(!this.defaultOptions.partialCount || this.totalRows < 100 ? 'datatable.range' : 'datatable.rangePartial', [
          this.perPage * (this.currentPage - 1) + 1,
          to,
          this.totalRows
        ])
      }
    },
    beforeCreate () {
      this.uuid = uuid.toString()
      uuid += 1
    },
    created () {
      this.query.parameters.filter = this.filterModel
      this.hasInvoiceExportClaim = hasInvoiceExportClaim()

      // Allow on-demand table refresh
      EventBus.$on('refresh-table', () => {
        this.sendRequest()
      })

      this.pushUrlToModel()
      this.pushModelToUrl()

      // Set perPage model and query parameter.
      this.perPage = this.query.parameters['perPage'] = this.opt.per_page_default

      // Set current page from cache
      var datatableInfo = getCurrentDatatableInfo(this)
      if (datatableInfo) {
        this.currentPage = datatableInfo.currentPage
        this.perPage = this.query.parameters['perPage'] = datatableInfo.currentPageSize ? datatableInfo.currentPageSize : this.opt.per_page_default
      } // Send initial request.

      this.sendRequest()
    },
    mounted () {
      this.createPaginationText()
      var elements = document.querySelectorAll('[id^="dropdown-"]')
      for (var i = 0; i < elements.length; i++) {
        elements[i].classList.remove('dropdown-toggle')
        elements[i].classList.add('p-0')
      }

      this.pushUrlToModel()
      this.pushModelToUrl()
      switch (this.$store.getters.dateLocale) {
        case 'sr-cyrl':
          this.dateLocale = srCYRL
          break
        case 'sr':
          this.dateLocale = sr
          break
        case 'en':
          this.dateLocale = en
          break
        default:
          this.dateLocale = srCYRL
      }
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>
  @import './datatable.scss';
</style>

<style lang="scss" type="text/scss">
  @import '~@/assets/scss/variables.scss';


  .table-datepicker {
    border: none !important;
    border-bottom: 1px solid $primary-color !important;

    font-size: 10pt !important;
  }

  .table-datepicker-wrapper {
    display: flex !important;
  }
</style>



// WEBPACK FOOTER //
// Datatable.vue?d2b1500a